export enum PILATES_VERSION {
	V1 = 'pilatesV1',
	V2 = 'pilatesV2',
	V3 = 'pilatesV3',
	V4 = 'pilatesV4',
	V5 = 'pilatesV5',
}
